<template>
  <div
    @click="$router.push({ path: '/marketplace' })"
    class="bg-ontick-steel-100 dark:bg-ontick-graphite-500 flex flex-col items-center justify-center rounded-lg p-4 shadow-md"
  >
    <div class="flex flex-col items-center justify-center space-y-2">
      <!-- :class="getVisualizationMode === 'mini-card' ? 'space-y-4' : 'space-y-6'" -->
      <!-- <h2
        class="
          text-xl
          dark:text-gray-300
          text-ontick-steel-500
          font-semibold
          whitespace-nowrap
        "
      >
        Novo investimento
      </h2> -->
      <span
        class="shadown bg-ontick-steel-500 dark:text-ontick-graphite-500 h-16 w-16 cursor-pointer rounded-full text-gray-50 transition-all duration-150 hover:rotate-90 hover:transform"
        v-html="$icons.add"
      ></span>

      <p
        class="text-ontick-carbon-900 text-center font-bold dark:text-gray-300"
      >
        Adicionar novo investimento
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({ getVisualizationMode: "investment/getVisualizationMode" }),
  },
};
</script>

<style></style>
